import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  const tokenAcesso = localStorage.getItem("tokenAcesso");

  const isValid = (t) => {
    if (!t) return false;
    const clean = t.replace(/^["']|["']$/g, "").trim();
    return clean !== "" && clean !== "undefined" && clean !== "null";
  };

  return isValid(tokenAcesso) || isValid(token);
};

const RestrictedRoute = ({ children }) => {
  const location = useLocation();

  // A loja (/ar/shop) possui visualização pública de catálogo para usuários não autenticados
  if (location.pathname === "/ar/shop" || location.pathname === "/ar/shop/") {
    return children;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/acesso" replace />;
  }

  return children;
};

export default RestrictedRoute;
